<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    getTags () {
      this.$store.dispatch('getTags')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getTags()
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Tags.vue?bdc3bc34